import NatureOfBusinessFormProvider, {
  useNatureOfBusinessForm,
} from './NatureOfBusinessFormProvider';

export { useNatureOfBusinessForm };
export default NatureOfBusinessFormProvider;
